import type { TokenPairResponse } from '../../api/auth';

// Tokens are stored in localStorage so the session survives closing the browser
// tab/window (the backend refresh token lives 365 days). sessionStorage cleared
// tokens on tab close, forcing admins to log in again on every new tab/session —
// the main cause of frequent logouts.
// For maximum security, the refresh token should be stored in an HttpOnly cookie
// set by the backend — this requires a backend change and eliminates JS-accessible
// token storage entirely.
const STORAGE_KEY = 'waf-crm-auth';

// Migrate any tokens left behind in the previous sessionStorage location so the
// switch to localStorage does not log the current user out.
function migrateLegacyTokens(): void {
  const legacy = window.sessionStorage.getItem(STORAGE_KEY);
  if (legacy && !window.localStorage.getItem(STORAGE_KEY)) {
    window.localStorage.setItem(STORAGE_KEY, legacy);
  }
  if (legacy) {
    window.sessionStorage.removeItem(STORAGE_KEY);
  }
}

export function loadTokens(): TokenPairResponse | null {
  migrateLegacyTokens();
  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as TokenPairResponse;
  } catch {
    window.localStorage.removeItem(STORAGE_KEY);
    return null;
  }
}

export function saveTokens(tokens: TokenPairResponse): void {
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(tokens));
}

export function clearTokens(): void {
  window.localStorage.removeItem(STORAGE_KEY);
  window.sessionStorage.removeItem(STORAGE_KEY);
}
